// Mantine
import { Button, Modal, TextInput } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { notifications } from '@mantine/notifications'

// Icons
import { Plus } from '@untitled-ui/icons-react'

// UI
import ComponentCategorySelect from '../ui/ComponentCategorySelect'

// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

import { useNavigate } from 'react-router-dom'

export default function ComponentAdd() {
    // Modal state
    const [opened, handlers] = useDisclosure()

    // Form
    const [name, setName] = useState('')
    const [category, setCategory] = useState(null)

    const navigate = useNavigate()

    const { requestPost } = useAxiosApi()

    const createComponent = async () => {
        const { data } = await requestPost('/components', {
            name: name,
            category: category,
        })

        if (data) {
            handlers.close()

            notifications.show({
                title: 'Composant créé',
                color: 'green',
            })

            navigate(
                '/components?orderBy=created_at&orderByDirection=desc&location_id=1&columns=created_at'
            )
        }
    }

    const isValid = name && category

    // Render
    return (
        <>
            <Button
                variant="light"
                color="dark"
                leftSection={<Plus width={14} height={14} />}
                onClick={() => handlers.open()}
            >
                Ajouter un composant
            </Button>

            <Modal
                opened={opened}
                onClose={() => handlers.close()}
                title="Ajouter un composant"
                size="md"
            >
                <div className="flex flex-col gap-3">
                    <ComponentCategorySelect
                        onChange={setCategory}
                        value={category}
                    />

                    <TextInput
                        label="Nom"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />

                    <Button onClick={createComponent} disabled={!isValid}>
                        Créer le composant
                    </Button>
                </div>
            </Modal>
        </>
    )
}
